import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>© 2025 Jayasankar |
          
          <a href="/contact" className="footer-link"> Contact</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;